<template>
  <v-dialog
    v-model="dialog"
    max-width="720"
    :persistent="saving"
    content-class="t112p-dialog"
  >
    <v-card>
      <div class="t112p-head">
        <div class="d-flex align-center" style="gap: 10px">
          <v-icon color="#1b5e20" size="24">mdi-school</v-icon>
          <span class="t112p-title">11 сарын 2-ны сургалт</span>
        </div>
        <div class="t112p-kicker">Сургалтын бүртгэл · {{ userData.school.name }}</div>
      </div>

      <v-card-text class="t112p-body">
        <div class="t112p-lead">
          Танай сургуулиас <b>11 сарын 2-ны сургалтад</b> оролцох багш бүртгэлд
          нэмэгдээгүй байна.
        </div>

        <div class="t112p-note">
          <div class="t112p-note-title">Анхаарах зүйлс</div>
          <div class="t112p-item">
            <span class="t112p-num" style="background: #fde68a; color: #92400e">1</span>
            <div class="t112p-item-title">Бүртгэлгүй багш сургалтад оролцох боломжгүй.</div>
          </div>
          <div class="t112p-item">
            <span class="t112p-num" style="background: #dcfce7; color: #166534">2</span>
            <div class="t112p-item-title">
              Бүртгүүлсэн багшид сургалтад оролцох холбоос автоматаар илгээгдэнэ.
            </div>
          </div>
        </div>

        <div class="t112p-info">
          <v-icon color="#9ca3af" size="18" class="mr-2">mdi-information-outline</v-icon>
          Оролцохгүй бол «Багш нар оролцохгүй» дарна уу.
        </div>
      </v-card-text>

      <v-card-actions class="t112p-foot">
        <v-btn
          outlined
          color="red darken-1"
          height="44"
          class="font-weight-bold text-none px-5"
          style="font-size: 15px; border-width: 2px; border-radius: 8px"
          :loading="saving"
          :disabled="saving"
          @click="decline"
        >
          <v-icon left size="20">mdi-close-circle-outline</v-icon>
          Багш нар оролцохгүй
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          :ripple="false"
          height="44"
          dark
          class="font-weight-bold text-none btn-primary bg-gradient-success px-6"
          style="font-size: 15px; border-radius: 8px"
          :disabled="saving"
          @click="register"
        >
          <v-icon left size="20">mdi-account-plus</v-icon>
          Багш нараа бүртгэх
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sync } from "vuex-pathify";
const fb = require("@/firebaseConfig.js");

export default {
  name: "Training112Prompt",
  data: () => ({
    dialog: false,
    saving: false,
  }),
  computed: {
    ...sync("*"),
  },
  async created() {
    const school = this.userData && this.userData.school;
    if (!school || !["schoolmanager", "superadmin"].includes(this.userData.role)) return;
    const datas = school.schoolDatas || {};
    if (datas.showTraining11_2 !== true || datas.training11_2Declined === true) return;
    try {
      const config = await fb.db.doc("_bagshSystemConfigurations/bagshWeb").get();
      if (!config.exists || config.data().askTraining11_2 !== true) return;
      const registered = await school.ref
        .collection("teachers")
        .where("training11_2", "==", true)
        .limit(1)
        .get();
      this.dialog = registered.empty;
    } catch (e) {
      console.warn("Training112Prompt", e);
    }
  },
  methods: {
    register() {
      this.dialog = false;
      this.$router.push("/Burtgel").catch(() => {});
    },
    async decline() {
      if (this.saving) return;
      const result = await this.$swal({
        title: "11 сарын 2-ны сургалтад оролцохгүй гэж бүртгэх үү?",
        text: "Дахин асуухгүй. Дараа нь «Бүртгэл» → «Сургалтын бүртгэл» табаас багш бүртгэж болно.",
        type: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn bg-gradient-success",
          cancelButton: "btn bg-gradient-danger",
        },
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        reverseButtons: true,
      });
      if (!result.isConfirmed) return;
      this.saving = true;
      try {
        await fb.db
          .collection("_schoolDatas")
          .doc(this.userData.school.id)
          .set(
            {
              training11_2Declined: true,
              training11_2DeclinedInfo: {
                updatedAt: new Date(),
                updatedByRef: this.userData.ref || null,
                updatedByName:
                  this.userData.DISPLAY_NAME ||
                  this.userData.FIRST_NAME ||
                  this.userData.firstName ||
                  this.userData.email ||
                  "",
              },
            },
            { merge: true },
          );
        this.dialog = false;
      } catch (e) {
        this.$swal.fire({ icon: "error", title: "Хадгалж чадсангүй", text: String(e.message || e) });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style>
.t112p-dialog {
  border-radius: 14px !important;
}
.t112p-dialog .t112p-head {
  padding: 16px 22px 14px;
  background: #e8f5e9;
  border-bottom: 1px solid #c8e6c9;
}
.t112p-dialog .t112p-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: #111827;
}
.t112p-dialog .t112p-kicker {
  margin-top: 4px;
  font-size: 14px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #2e7d32;
}
.t112p-dialog .t112p-body {
  padding: 20px 22px 6px !important;
}
.t112p-dialog .t112p-lead {
  font-size: 17px;
  line-height: 1.5;
  color: #1f2937;
}
.t112p-dialog .t112p-note {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}
.t112p-dialog .t112p-note-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 6px;
}
.t112p-dialog .t112p-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
}
.t112p-dialog .t112p-item + .t112p-item {
  border-top: 1px solid #e5e7eb;
}
.t112p-dialog .t112p-num {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  margin-top: 1px;
}
.t112p-dialog .t112p-item-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  color: #111827;
}
.t112p-dialog .t112p-info {
  display: flex;
  align-items: center;
  margin-top: 14px;
  font-size: 15px;
  color: #6b7280;
}
.t112p-dialog .t112p-foot {
  padding: 14px 22px 20px !important;
}
</style>
